import React from 'react';
import { createRoot } from 'react-dom/client';
import './assets/css/index.scss';
import './assets/css/fonts.scss';
import RootScreen from './screens/RootScreen/RootScreen';
import { BrowserRouter } from 'react-router-dom';
import ChakraContext from './context/ChakraContext';
import { MapContextProvider } from './context/MapContext';
import { UIContextProvider } from './context/UIContext';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react'

posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2025-11-30',
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <PostHogProvider client={posthog}>
        <BrowserRouter>
            <ChakraContext>
                <UIContextProvider>
                    <MapContextProvider>
                            <RootScreen />
                    </MapContextProvider>
                </UIContextProvider>
            </ChakraContext>
        </BrowserRouter>
    </PostHogProvider>
);
